// extracted by mini-css-extract-plugin
module.exports = {"download":"report_download__yH53s","QRwrapper":"report_QRwrapper__3kx1-"};